import React from "react";
import { INoticeDetails } from "../../../models/interfaces/INotice";


interface IProps {
  NoticeResult: INoticeDetails;
}

const Bloc8: React.FC<IProps> = ({ NoticeResult }) => {
  return (
    <>
    {NoticeResult?.resumeElectre && (
          <>
            <div className="card" style={{ textAlign: 'left' }}>
              <div className="col-sm-12 card-body pae-card-grey" >
                <b className="pae-detail-section-title mb-2">Résumé Electre</b>
              </div>
              <div className="col-sm-12 card-body">
                {NoticeResult?.resumeElectre}
              </div>
            </div> 
            <br></br>
          </>
        )}
    </>
  );
};

export default Bloc8;
